/* eslint-disable @typescript-eslint/naming-convention */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { DATE_RANGE_OPTIONS } from "@/shared/constants";

export interface DashboardFilterState {
  dateMode: string;
  from_date: string;
  to_date: string;
  timezone: string;
}

const initialState: DashboardFilterState = {
  dateMode: DATE_RANGE_OPTIONS[4].value, // Default to "Last 30 Days"
  from_date: "",
  to_date: "",
  timezone: "",
};

const dashboardFilterSlice = createSlice({
  name: "dashboardFilter",
  initialState,
  reducers: {
    setDateMode(state, action: PayloadAction<string>) {
      state.dateMode = action.payload;
    },
    setFromDate(state, action: PayloadAction<string>) {
      state.from_date = action.payload;
    },
    setToDate(state, action: PayloadAction<string>) {
      state.to_date = action.payload;
    },
    setTimezone(state, action: PayloadAction<string>) {
      state.timezone = action.payload;
    },
    setDashboardFilters(
      state,
      action: PayloadAction<Partial<DashboardFilterState>>,
    ) {
      return { ...state, ...action.payload };
    },
    resetDashboardFilters() {
      return initialState;
    },
  },
});

export const {
  setDateMode,
  setFromDate,
  setToDate,
  setTimezone,
  setDashboardFilters,
  resetDashboardFilters,
} = dashboardFilterSlice.actions;

export default dashboardFilterSlice.reducer;
